export const SAVE_MANUAL_DEXTERITY_RESET = "SAVE_MANUAL_DEXTERITY_RESET"
export const SAVE_MANUAL_DEXTERITY_REQUEST = "SAVE_MANUAL_DEXTERITY_REQUEST"
export const SAVE_MANUAL_DEXTERITY_SUCCESS = "SAVE_MANUAL_DEXTERITY_SUCCESS"
export const SAVE_MANUAL_DEXTERITY_FAILURE = "SAVE_MANUAL_DEXTERITY_FAILURE"


export const FETCH_MANUAL_DEXTERITY_REQUEST = "FETCH_MANUAL_DEXTERITY_REQUEST"
export const FETCH_MANUAL_DEXTERITY_SUCCESS = "FETCH_MANUAL_DEXTERITY_SUCCESS"
export const FETCH_MANUAL_DEXTERITY_FAILURE = "FETCH_MANUAL_DEXTERITY_FAILURE"